import { render, staticRenderFns } from "./location-filterable-card.vue?vue&type=template&id=c838550a"
import script from "./location-filterable-card.vue?vue&type=script&lang=js"
export * from "./location-filterable-card.vue?vue&type=script&lang=js"
import style0 from "./location-filterable-card.vue?vue&type=style&index=0&id=c838550a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports